<template>
  <div id="container" class="svg-container">
    <svg :id="'pl' + player_id"></svg>
    <div :id="'tooltip' + player_id" class="tooltip">
      <p class="hidden">
        <strong><span id="value"></span></strong>
      </p>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";

export default {
  props: {
    player_id: {
      type: Number,
      required: true,
    },
    player_avatar: {
      type: String,
      required: true,
    },
    player_data: {
      type: Array,
      required: true,
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
  },

  data() {
    return {
      chart: null,
    };
  },

  computed: {},

  mounted() {
    this.plotChart();
  },

  methods: {
    plotChart() {
      const radius = Math.min(this.width, this.height) / 2 - 10;
      const innerRadius = 0.3 * radius;
      const innerRadius2 = 0.2 * radius;

      const pie = d3
        .pie()
        .sort(null)
        .value(function (d) {
          return d.width;
        });

      const arc = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius(function (d) {
          var diff = radius - innerRadius - 15;
          var tot = (diff * d.data.score) / 85;
          tot = tot + innerRadius + 2;
          return Math.round(tot * 100) / 100;
        })
        .startAngle(function (d) {
          return d.startAngle - Math.PI / 4;
        })
        .endAngle(function (d) {
          return d.endAngle - Math.PI / 4;
        });

      const outlineArc2 = d3
        .arc()
        .innerRadius(innerRadius2)
        .outerRadius(radius)
        .startAngle(function (d) {
          return d.startAngle - Math.PI / 4;
        })
        .endAngle(function (d) {
          return d.endAngle - Math.PI / 4;
        });

      const svg = d3
        .select("#pl" + this.player_id)
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", `0 0 ${this.width} ${this.height}`)
        .classed("svg-content", true);

      this.chart = svg
        .append("g")
        .attr(
          "transform",
          "translate(" + this.width / 2 + "," + this.height / 2 + ")"
        );

      this.player_data.forEach(function (d) {
        d.id;
        d.order = +d.order;
        d.color;
        d.weight = +d.weight;
        d.score;
        d.width = +d.weight;
        d.label;
        d.sigla;
      });

      const arcs = this.chart
        .selectAll(".solidArc")
        .data(pie(this.player_data))
        .enter()
        .append("path")
        .attr("fill", function (d) {
          return d.data.color;
        })
        .attr("class", "solidArc")
        .attr("stroke", "#080D19")
        .style("stroke-width", 2);

      arcs
        .transition()
        .ease(d3.easeBounce)
        .delay(function (d, i) {
          return i * 70;
        })
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      const playerId = this.player_id;

      arcs.on("mouseover", function (d) {
        d3.select(this).style("fill", "#66ccff");
        d3.select("#tooltip" + playerId)
          // .style("left", d3.event.pageX - 30 + "px")
          // .style("top", d3.event.pageY - 50 + "px")
          .style("opacity", 1)
          .select("#value")
          .text(d.data.label + ": " + d.data.value);
      });
      arcs.on("mouseout", function (d) {
        d3.select(this).style("fill", d.data.color);
        d3.select("#tooltip" + playerId).style("opacity", 0);
      });

      this.chart
        .append("circle")
        //  .attr("fill", "#080D19")
        .attr("fill", "transparent")
        //  .attr("r", 98);
        .attr("r", this.width / 6);

      const arcs2 = this.chart
        .selectAll(".outlineArc2")
        .data(pie(this.player_data))
        .enter()
        .append("path")
        .attr("fill", "transparent")
        .attr("stroke", "rgba(255,255,255, 0.2)")
        .style("stroke-width", 1)
        .attr("class", "outlineArc2")
        .attr("d", outlineArc2);

      //  arcs2.on("mouseover", function (event, d) { /*** RAF: con aggiornamento d3 ***/
      arcs2.on("mouseover", function (d) {
        d3.select(this).style("stroke", "#66ccff").style("stroke-width", 4);
        d3.select("#tooltip" + playerId)
          .style("opacity", 1)
          .select("#value")
          .text(d.data.label + ": " + d.data.value);
      });
      arcs2.on("mouseout", function (d) {
        d3.select(this)
          .style("stroke", "rgba(255,255,255, 0.2)")
          .style("stroke-width", 1);
        d3.select("#tooltip" + playerId).style("opacity", 0);
      });

      this.chart
        .append("circle")
        .attr("fill", "#FFFFFF")
        //   .attr("r", 75);
        .attr("r", this.width / 9);

      const defs = this.chart
        .append("defs")
        .attr("id", "imgdefs" + this.player_id);

      const catpattern = defs
        .append("pattern")
        .attr("id", "catpattern" + this.player_id)
        .attr("height", 1)
        .attr("width", 1)
        .attr("x", "0")
        .attr("y", "0")
        .attr("fill", "#EEEEEE");

      catpattern
        .append("image")
        .attr("x", -4)
        .attr("y", 0)
        .attr("height", this.width / 3.5)
        .attr("width", this.width / 3.5)
        .attr("xlink:href", this.player_avatar);

      this.chart
        .append("a")
        .attr("xlink:href", "/scouting/view/player/" + this.player_id)
        .attr("target", "_blank")
        .append("ellipse")
        .attr("rx", this.width / 8)
        .attr("ry", this.width / 7)
        // .attr("cy", -6)
        .attr("cx", 0)
        .attr("cy", -8)
        .attr("fill", "url(#catpattern" + this.player_id + ")");

      // Labels
      const labelRadius = radius + 2;

      const labels = this.chart.append("g").classed("labels", true);

      labels
        .append("def")
        .append("path")
        .attr("id", "label-path")
        .attr(
          "d",
          "m0 " +
            -labelRadius +
            " a" +
            labelRadius +
            " " +
            labelRadius +
            " 0 1,1 -0.01 0"
        );

      const count = this.player_data.length;
      labels
        .selectAll("text")
        .data(this.player_data)
        .enter()
        .append("text")
        .attr("font-size", "0.65rem")
        .style("text-anchor", "middle")
        .style("font-weight", "bold")
        .style("fill", function (d, i) {
          return "#FFF";
        })
        .append("textPath")
        .attr("xlink:href", "#label-path")
        .attr("startOffset", function (d, i) {
          var offset = (i * 100) / count - 100 / count;
          if (offset < 0) {
            offset = 100 + offset;
          }
          if (offset == 0) {
            offset = 0.7467;
          }
          return offset + "%";
        })
        .text(function (d) {
          return d.sigla;
        });
    },
  },
};
</script>
<style>
.tooltip {
  position: absolute;
  z-index: 999;
  width: 150px;
  height: auto;
  padding: 5px 10px 5px 10px;
  background: rgba(255, 255, 255, 0.8);
  color: #000;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  -webkit-box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.4);
  -mox-box-shadow: 4px 4px 4px 10px rgba(0, 0, 0, 0.4);
  box-shadow: 4px 4px 10px rbga(0, 0, 0, 0.4);
  pointer-events: none;
}
.tooltip.hidden {
  opacity: 0;
}
.tooltip p {
  margin: 0;
  font-size: 10px;
  line-height: 20px;
}
</style>
